export default __webpack_public_path__ + "images/c9960c648b7e9d55fc88bb233dc7209a.svg";